<template>
  <div>
    <el-dialog
      title="设置摄像头类型"
      class="dialog"
      :visible="visible"
      width="500px"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :before-close="handleCancel"
    >
      <div class="main">
        <div class="left">常用单选框：</div>
        <el-radio-group v-model="ptzType" class="radio-group">
          <el-radio :label="0">常规</el-radio>
          <el-radio :label="1">云台（有坐标）</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button :disabled="isDisabled" type="primary" :loading="isSubmitting" @click="handleConfirm">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { batchUpdatePtzType } from 'src/api/legacy'

export default {
  data() {
    return {
      visible: false,
      isDisabled: false,
      isSubmitting: false,

      cameraId: undefined,
      ptzType: 0,
    }
  },
  props: {},
  mounted() {},
  watch: {},
  methods: {
    handleOpen(data) {
      this.visible = true
      this.cameraId = data.cameraId
      this.ptzType = data.ptzType || 0
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
    async handleConfirm() {
      const params = {
        cameraIds: [this.cameraId],
        ptzType: this.ptzType,
      }
      const res = await batchUpdatePtzType(params)
      if (res.status === 0) {
        this.$message({
          type: 'success',
          message: '修改成功',
        })
        this.$emit('update')
        this.handleCancel()
      }
    },
  },
}
</script>

<style scoped lang="less">
.dialog {
  .main {
    display: flex;
    justify-content: flex-start;
    .left {
      text-align: right;
      width: 150px;
      line-height: 1;
    }
    .radio-group {
      display: flex;
      flex-wrap: wrap;
      gap: 15px;
      width: 200px;
    }
  }

  /deep/ .el-dialog__footer {
    border-top: 1px solid #e6e6e6;
  }
}
</style>
